const GLOBALS = {
    TOP_OF_INNING: 'Top',
    BOTTOM_OF_INNING: 'Bottom',
    SO: 'so',
    OO: 'oo',
    H1: 'h1',
    H2: 'h2',
    H3: 'h3',
    HR: 'hr',
    BB: 'bb',
    K_AFFECT_PCT: 0.5,
    GAME_SPEED: {
        NORMAL: { name: 'normal', value: 1 },
        FAST: { name: 'fast', value: 0.7 },
        FASTER: { name: 'faster', value: 0.4 },
        INSTANT: { name: 'instant', value: 0 },
    },
    FIRST_YEAR: 1871,
    LAST_YEAR: 2025,
    LOW_IPOUTS: 50,
    LOW_IP: 18,
    LOW_AB: 80,
    MID_EVENTS: ['oo', 'h1', 'h2'],
    MANAGED_EVENTS: {
        BB: { name: 'bb', allowed: 'Pitcher' },
        STEAL: { name: 'steal', allowed: 'Batter' },
        EXTRA_BASE: { name: 'extraBase', allowed: 'Batter' },
        BUNT: { name: 'bunt', allowed: 'Batter' },
    },
    // Batters are blocked after 2 full games (9 fatigue per game)
    BATTER_FATIGUE_THRESHOLD: 18,
    DEFAULT_PITCHER_STAMINA: 27,

    // Cost to go from the given level to the next. Levels are uncapped.
    // 100·2^L for L≤3, then 800·L − 1600 (i.e. +800 per level after 1600).
    CARD_UPGRADE_COST: level => (level <= 3 ? 100 * Math.pow(2, level) : 800 * level - 1600),
    CARD_UPGRADE_MONEY_COST: level => {
        const expCost = level <= 3 ? 100 * Math.pow(2, level) : 800 * level - 1600;
        return Math.floor(expCost / 2);
    },

    CARD_UPGRADE_EFFECTS: {
        batter: {
            speedPerPoint: 3,
            fatigueThresholdPerPoint: 9,
            powerRerollChancePerPointPct: 5,
            powerRerollChanceCapPct: 50,
        },
        pitcher: {
            staminaPerPoint: 3,
            ratingPerPoint: 2,
            kConvertBasePct: 50,
            kConvertPerPointPct: 2.5,
            kConvertCapPct: 75,
            fatigueFlipBasePct: 20,
            fatigueFlipReductionPerPointPct: 3,
            fatigueFlipFloorPct: 0,
        },
    },

    CONTEST_STATUS: {
        COMPLETED: 'completed',
        IN_PROGRESS: 'in-progress',
    },

    RESULT: {
        WIN: 'Win',
        LOSS: 'Loss',
        RESIGNED: 'Resigned',
        CSS: {
            Win: 'win',
            Loss: 'loss',
            Resigned: 'resigned',
        },
        LABEL: {
            Win: 'Won',
            Loss: 'Lost',
            Resigned: 'Resigned',
        },
    },
    TRADE_UP_CARDS_REQUIRED: 3,

    CARD_RARITIES: {
        IRON: 'iron',
        BRONZE: 'bronze',
        SILVER: 'silver',
        GOLD: 'gold',
        TITANIUM: 'titanium',
        URANIUM: 'uranium',
    },

    RARITY_TIERS: ['iron', 'bronze', 'silver', 'gold', 'titanium', 'uranium'],

    RARITY_DISPLAY: {
        iron: { label: 'Iron', rating: 55 },
        bronze: { label: 'Bronze', rating: 65 },
        silver: { label: 'Silver', rating: 75 },
        gold: { label: 'Gold', rating: 85 },
        titanium: { label: 'Titanium', rating: 95 },
        uranium: { label: 'Uranium', rating: 96 },
    },

    NEXT_RARITY: {
        iron: 'bronze',
        bronze: 'silver',
        silver: 'gold',
        gold: 'titanium',
        titanium: 'uranium',
    },

    AUTO_MANAGER: {
        MODES: ['safe', 'normal', 'crazy'],
        SAFE: { key: 'safe', label: 'Safe', mobileLabel: 'Safe' },
        NORMAL: { key: 'normal', label: 'Normal', mobileLabel: 'Nrml' },
        CRAZY: { key: 'crazy', label: 'Krazy Kev', mobileLabel: 'Kev' },
        CSS: { safe: 'auto-safe', normal: 'auto-normal', crazy: 'auto-crazy' },
    },
    GAME_EVENT_RESULTS: [
        { value: 'so', label: 'Strikeout (SO)' },
        { value: 'oo', label: 'Out (OO)' },
        { value: 'bb', label: 'Walk (BB)' },
        { value: 'h1', label: 'Single (H1)' },
        { value: 'h2', label: 'Double (H2)' },
        { value: 'h3', label: 'Triple (H3)' },
        { value: 'hr', label: 'Home Run (HR)' },
    ],
    CONSTRAINT_SIDES: [
        { value: 'user', label: 'User' },
        { value: 'opponent', label: 'Opponent' },
    ],
    BATTING_POSITIONS: ['C', '1B', '2B', '3B', 'SS', 'LF', 'CF', 'RF', 'DH'],
    DISCORD_INVITE_URL: 'https://discord.gg/gre3rv7aCu',
    HOME_ROLE: 'home',
    AWAY_ROLE: 'away',
    PLAYOFF_STATUS: {
        ACTIVE: 'active',
        ELIMINATED: 'eliminated',
        CHAMPION: 'champion',
    },
    PLAYOFF_ROUND_NAMES: ['', 'Wild Card', 'Division Series', 'Championship', 'World Series'],
    PLAYOFF_SERIES_NAMES: ['', 'AA', 'AAA', 'Playoffs'],
    PLAYOFF_GAMES_PER_SERIES: 4,
    PLAYOFF_TOTAL_ROUNDS: 12,
    PLAYOFF_SERIES_REWARDS: {
        1: ['', '1 Random Pack', '3 Random Packs', '1 Silver + 1 Random', '1 Gold Pack'],
        2: ['', '2 Random Packs', '4 Random Packs', '1 Silver + 2 Random', '1 Gold + 1 Random'],
        3: ['', '3 Random Packs', '5 Random Packs', '1 Silver + 3 Random', '1 Gold + 2 Random'],
    },
    PLAYOFF_TROPHY_TIERS: { bronze: 'Bronze', silver: 'Silver', gold: 'Gold' },
    STADIUM_MODE: {
        DEFAULT: 'default',
        RANDOM: 'random',
        SELECTED: 'selected',
    },
    COSMETIC_TYPE: {
        DICE: 'dice',
        MEEPLE: 'meeple',
    },
    COSMETIC_MODE: {
        DEFAULT: 'default',
        RANDOM: 'random',
        SELECTED: 'selected',
    },
    SPECIAL_GAME_TYPES: {
        RADIOACTIVE: 'radioactive',
        CORRUPTED: 'corrupted',
    },
    SPECIAL_GAME_BG: {
        radioactive: 'special-game-radioactive',
        corrupted: 'special-game-corrupted',
    },
    BADGE_TIERS: {
        1: { label: 'Bronze', cssClass: 'badge-bronze' },
        2: { label: 'Silver', cssClass: 'badge-silver' },
        3: { label: 'Gold', cssClass: 'badge-gold' },
        4: { label: 'Diamond', cssClass: 'badge-diamond' },
    },
};

export default GLOBALS;
